import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Layers } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

const JOURNAL_COLORS = {
  CA: "bg-green-100 text-green-800",
  BQ: "bg-blue-100 text-blue-800",
  MM: "bg-orange-100 text-orange-800",
  VE: "bg-emerald-100 text-emerald-800",
  AC: "bg-amber-100 text-amber-800",
  SA: "bg-purple-100 text-purple-800",
  OD: "bg-slate-200 text-slate-800",
  AN: "bg-cyan-100 text-cyan-800",
};

export default function JournauxPage() {
  const [journals, setJournals] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/accounting/journals");
        setJournals(data);
        // count entries per journal
        const allEntries = await api.get("/accounting/entries");
        const c = {};
        allEntries.data.forEach(e => { c[e.journal] = (c[e.journal] || 0) + 1; });
        setCounts(c);
      } catch {
        toast.error("Erreur de chargement des journaux");
      }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="journaux-page">
      <div>
        <div className="chip mb-2"><Layers className="h-3 w-3" /><span>JOURNAUX COMPTABLES</span></div>
        <h1 className="font-heading font-extrabold text-3xl text-[#1E3A8A]">Journaux comptables</h1>
        <p className="text-slate-500 mt-1">{journals.length} journaux configurés. Cliquez pour consulter les écritures.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {journals.map(j => (
          <Link key={j.code} to={`/dashboard/comptabilite/saisies?journal=${j.code}`} className="block bg-white rounded-2xl border border-slate-200 hover:border-[#1E3A8A] hover:shadow-lg transition-all p-5" data-testid={`journal-${j.code}`}>
            <div className="flex items-center justify-between mb-3">
              <span className={`inline-block px-3 py-1 rounded-lg font-bold font-mono ${JOURNAL_COLORS[j.code] || "bg-slate-100 text-slate-800"}`}>{j.code}</span>
              <span className="text-xs text-slate-400 tabular-nums">{counts[j.code] || 0} écritures</span>
            </div>
            <div className="font-heading font-bold text-lg text-[#1E3A8A]">{j.name}</div>
            <div className="text-sm text-slate-500 mt-2">Voir les écritures →</div>
          </Link>
        ))}
        {journals.length === 0 && (
          <div className="md:col-span-2 lg:col-span-3 bg-white rounded-2xl border border-dashed border-slate-300 p-10 text-center text-slate-500">
            Aucun journal. Initialisez le plan comptable depuis le tableau de bord.
          </div>
        )}
      </div>
    </div>
  );
}
